import { createContext, lazy } from "react";
const Info = lazy(() => import("./Info"));
const InfoOverlay = lazy(() => import("./InfoOverlay"));
const InfoPopover = lazy(() => import("./InfoPopover"));
const InfoDialog = lazy(() => import("./InfoDialog"));
const InfoButton = lazy(() => import("./InfoButton"));
const InfoText = lazy(() => import("./InfoText"));
const InfoTextMarkdown = lazy(() => import("./InfoTextMarkdown"));
const InfoTextPlain = lazy(() => import("./InfoTextPlain"));
const InfoImages = lazy(() => import("./InfoImages"));
const InfoFiles = lazy(() => import("./InfoFiles"));
/**
 * Values must start with value to be picked up by the renderer
 */
export const InfoComponents = {
    Info,
    InfoButton,
    InfoOverlay,
    InfoPopover,
    InfoDialog,
    InfoText,
    InfoImages,
    InfoFiles,
    InfoTextMarkdown,
    InfoTextPlain,
};
export const InfoComponentsContext = createContext(InfoComponents);
InfoComponentsContext.displayName = "InfoComponentsContext";
//# sourceMappingURL=InfoComponents.js.map